
import PropTypes from 'prop-types';

const TextBtn = ({clickHandler, text}) => {
  return (
    <button
      type="button"
      className="btn btn-outline-primary btn-sm input-radius"
      onClick={clickHandler}>
      <em>{text}</em>
    </button>
  );
};

TextBtn.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default TextBtn;
